import { ExternalEntityAssociationViewModel, ExternalEntityAssociationCreateCommand, ExternalEntityAssociationUpdateCommand } from '../../models/Entities/Person/ExternalAssociation/ExternalAssociationModels';
import { ErrorType } from '../../models/HttpError';

export const PERSON_EXTERNAL_ASSOCIATION_GETALL_REQUEST = 'PERSON_EXTERNAL_ASSOCIATION_GETALL_REQUEST';
export const PERSON_EXTERNAL_ASSOCIATION_GETALL_SUCCESS = 'PERSON_EXTERNAL_ASSOCIATION_GETALL_SUCCESS';
export const PERSON_EXTERNAL_ASSOCIATION_GETALL_FAILURE = 'PERSON_EXTERNAL_ASSOCIATION_GETALL_FAILURE';

export interface PersonExternalAssociationGetAllRequestAction {
    type: typeof PERSON_EXTERNAL_ASSOCIATION_GETALL_REQUEST;
    personId: number;
}

export interface PersonExternalAssociationGetAllSuccessAction {
    type: typeof PERSON_EXTERNAL_ASSOCIATION_GETALL_SUCCESS;
    personId: number;
    payload: ExternalEntityAssociationViewModel[];
}

export interface PersonExternalAssociationGetAllFailureAction {
    type: typeof PERSON_EXTERNAL_ASSOCIATION_GETALL_FAILURE;
    error: ErrorType;
}

export const PERSON_EXTERNAL_ASSOCIATION_GETBYID_REQUEST = 'PERSON_EXTERNAL_ASSOCIATION_GETBYID_REQUEST';
export const PERSON_EXTERNAL_ASSOCIATION_GETBYID_SUCCESS = 'PERSON_EXTERNAL_ASSOCIATION_GETBYID_SUCCESS';
export const PERSON_EXTERNAL_ASSOCIATION_GETBYID_FAILURE = 'PERSON_EXTERNAL_ASSOCIATION_GETBYID_FAILURE';

export interface PersonExternalAssociationGetByIdRequestAction {
    type: typeof PERSON_EXTERNAL_ASSOCIATION_GETBYID_REQUEST;
    id: number;
}

export interface PersonExternalAssociationGetByIdSuccessAction {
    type: typeof PERSON_EXTERNAL_ASSOCIATION_GETBYID_SUCCESS;
    payload: ExternalEntityAssociationViewModel;
}

export interface PersonExternalAssociationGetByIdFailureAction {
    type: typeof PERSON_EXTERNAL_ASSOCIATION_GETBYID_FAILURE;
    error: ErrorType;
}

export const PERSON_EXTERNAL_ASSOCIATION_CREATE_REQUEST = 'PERSON_EXTERNAL_ASSOCIATION_CREATE_REQUEST';
export const PERSON_EXTERNAL_ASSOCIATION_CREATE_SUCCESS = 'PERSON_EXTERNAL_ASSOCIATION_CREATE_SUCCESS';
export const PERSON_EXTERNAL_ASSOCIATION_CREATE_FAILURE = 'PERSON_EXTERNAL_ASSOCIATION_CREATE_FAILURE';

export interface PersonExternalAssociationCreateRequestAction {
    type: typeof PERSON_EXTERNAL_ASSOCIATION_CREATE_REQUEST;
    payload: ExternalEntityAssociationCreateCommand;
}

export interface PersonExternalAssociationCreateSuccessAction {
    type: typeof PERSON_EXTERNAL_ASSOCIATION_CREATE_SUCCESS;
    payload: ExternalEntityAssociationViewModel;
}

export interface PersonExternalAssociationCreateFailureAction {
    type: typeof PERSON_EXTERNAL_ASSOCIATION_CREATE_FAILURE;
    error: ErrorType;
}

export const PERSON_EXTERNAL_ASSOCIATION_UPDATE_REQUEST = 'PERSON_EXTERNAL_ASSOCIATION_UPDATE_REQUEST';
export const PERSON_EXTERNAL_ASSOCIATION_UPDATE_SUCCESS = 'PERSON_EXTERNAL_ASSOCIATION_UPDATE_SUCCESS';
export const PERSON_EXTERNAL_ASSOCIATION_UPDATE_FAILURE = 'PERSON_EXTERNAL_ASSOCIATION_UPDATE_FAILURE';

export interface PersonExternalAssociationUpdateRequestAction {
    type: typeof PERSON_EXTERNAL_ASSOCIATION_UPDATE_REQUEST;
    payload: ExternalEntityAssociationUpdateCommand;
}

export interface PersonExternalAssociationUpdateSuccessAction {
    type: typeof PERSON_EXTERNAL_ASSOCIATION_UPDATE_SUCCESS;
    payload: ExternalEntityAssociationViewModel;
}

export interface PersonExternalAssociationUpdateFailureAction {
    type: typeof PERSON_EXTERNAL_ASSOCIATION_UPDATE_FAILURE;
    id: number;
    error: ErrorType;
}

export const PERSON_EXTERNAL_ASSOCIATION_DELETE_REQUEST = 'PERSON_EXTERNAL_ASSOCIATION_DELETE_REQUEST';
export const PERSON_EXTERNAL_ASSOCIATION_DELETE_SUCCESS = 'PERSON_EXTERNAL_ASSOCIATION_DELETE_SUCCESS';
export const PERSON_EXTERNAL_ASSOCIATION_DELETE_FAILURE = 'PERSON_EXTERNAL_ASSOCIATION_DELETE_FAILURE';

export interface PersonExternalAssociationDeleteRequestAction {
    type: typeof PERSON_EXTERNAL_ASSOCIATION_DELETE_REQUEST;
    id: number;
}

export interface PersonExternalAssociationDeleteSuccessAction {
    type: typeof PERSON_EXTERNAL_ASSOCIATION_DELETE_SUCCESS;
    id: number;
}

export interface PersonExternalAssociationDeleteFailureAction {
    type: typeof PERSON_EXTERNAL_ASSOCIATION_DELETE_FAILURE;
    id: number;
    error: ErrorType;
}
